import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  defaultMarkerColor = "rgb(34 197 94)"
  defaultMarkerName = "FreehandMarker"

  connect(){
    this.selectMarkerColor(this.defaultMarkerColor)
    this.selectMarkerName(this.defaultMarkerName)
  }

  toggleVisibility(params){
    const { isVisible } = params

    const isOverlayVisible = isVisible ?? this.getVisibility()

    // Toggle overlay visibility
    this.element.dataset.visible = !isOverlayVisible
  }

  selectMarkerName(name){
    const buttonElements = this.element.querySelectorAll("[data-marker-name]")
    buttonElements.forEach((buttonElement) => {
      const { dataset: { markerName } } = buttonElement
      buttonElement.dataset.selected = markerName === name
    })
  }

  selectMarkerProperty(name, value){
    if (name === 'markerStrokeColor'){
      this.selectMarkerColor(value)
    }
  }
  
  selectMarkerColor(value){
    const buttonElements = this.element.querySelectorAll("[data-marker-property-name='markerStrokeColor']")
    buttonElements.forEach((buttonElement) => {
      const { dataset: { markerPropertyValue } } = buttonElement
      buttonElement.dataset.selected = markerPropertyValue === value
    })
  }
}
